import { render, staticRenderFns } from "./CentralButtons.vue?vue&type=template&id=131ee9ce&"
import script from "./CentralButtons.vue?vue&type=script&lang=js&"
export * from "./CentralButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports